module.exports = __webpack_public_path__ + "static/img/1.099343a6.png";